/** Secciones cerradas del sidenav por persona y contexto (`admin`/`tenant`). Sin dato, todo queda
 * abierto: un fallo de lectura nunca esconde navegación. */
const PREFIX = 'kairos.sidenav.collapsed'

function keyFor(scope: string): string {
  return `${PREFIX}.${scope}`
}

function readIds(scope: string): string[] {
  const raw = localStorage.getItem(keyFor(scope))
  if (!raw) return []
  const parsed: unknown = JSON.parse(raw)
  return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : []
}

export function readCollapsed(scope: string, id: string): boolean {
  try {
    return readIds(scope).includes(id)
  } catch {
    return false
  }
}

export function writeCollapsed(scope: string, id: string, collapsed: boolean): void {
  try {
    const ids = new Set(readIds(scope))
    if (collapsed) ids.add(id)
    else ids.delete(id)
    localStorage.setItem(keyFor(scope), JSON.stringify([...ids]))
  } catch {
    // Cuota llena o modo privado: la sección ya se plegó en pantalla.
  }
}
